(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product-slider"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.pde-featured-slider').forEach((root)=>{
  const track=root.querySelector('.pde-featured-slider__track');
  const slides=[...root.querySelectorAll('[data-slide]')];
  if(!track||slides.length<2)return;
  let index=0;
  const dots=root.querySelector('.pde-featured-slider__dots');
  const buttons=slides.map((_,i)=>{
    const b=document.createElement('button');
    b.type='button';
    b.setAttribute('aria-label','Product '+(i+1));
    b.addEventListener('click',()=>go(i));
    dots.appendChild(b);
    return b;
  });
  function go(i){index=(i+slides.length)%slides.length;track.style.transform='translateX(-'+(index*100)+'%)';buttons.forEach((b,n)=>b.setAttribute('aria-current',n===index?'true':'false'))}
  root.querySelector('.pde-featured-slider__prev').addEventListener('click',()=>go(index-1));
  root.querySelector('.pde-featured-slider__next').addEventListener('click',()=>go(index+1));
  go(0);
  const seconds=Number(root.dataset.autoplay||0);
  if(seconds>0){let timer=setInterval(()=>go(index+1),seconds*1000);root.addEventListener('mouseenter',()=>clearInterval(timer),{once:true})}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pde-adventure-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pde-video-carousel')) {
  customElements.define('pde-video-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.pde-reels-track');
      this.cards = Array.from(this.querySelectorAll('.pde-reel'));
      this.videos = Array.from(this.querySelectorAll('video'));
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.index = 0;
      this.pauseAll = () => this.videos.forEach(video => video.pause());
      this.update = () => {
        const next = this.cards.reduce((best, card, i) => Math.abs(card.getBoundingClientRect().left - this.track.getBoundingClientRect().left) < Math.abs(this.cards[best].getBoundingClientRect().left - this.track.getBoundingClientRect().left) ? i : best, 0);
        if (next !== this.index) this.pauseAll();
        this.index = next;
        this.querySelector('[data-reel-step="-1"]').disabled = this.track.scrollLeft < 3;
        this.querySelector('[data-reel-step="1"]').disabled = this.track.scrollWidth - this.track.clientWidth - this.track.scrollLeft < 3;
      };
      this.querySelectorAll('[data-reel-step]').forEach(button => button.addEventListener('click', () => {
        const target = this.cards[Math.min(this.cards.length - 1, Math.max(0, this.index + Number(button.dataset.reelStep)))];
        if (target) this.track.scrollTo({left: this.track.scrollLeft + target.getBoundingClientRect().left - this.track.getBoundingClientRect().left - 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, options));
      this.track.addEventListener('scroll', this.update, {...options, passive: true});
      this.addEventListener('play', event => this.videos.forEach(video => {if (video !== event.target) video.pause();}), {...options, capture: true});
      document.addEventListener('visibilitychange', () => {if (document.hidden) this.pauseAll();}, options);
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.track);
      this.visibility = new IntersectionObserver(entries => {if (!entries[0].isIntersecting) this.pauseAll();});
      this.visibility.observe(this);
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      this.visibility?.disconnect();
      this.pauseAll?.();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
